import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './TransactionCard.css';
import {RootState} from '../../../redux/store.type';
import TransactionDetails from './TransactionDetails/TransactionDetails';
import TransactionActions from './TransactionActions/TransactionActions';
import useCollapseOnScroll from './useCollapseOnScroll';

function TransactionCard() {
    const {t} = useTranslation('eTicket');
    const data = useSelector((state: RootState) => state.eTicket.data);
    const {collapsed, expand, ref} = useCollapseOnScroll();
    if(!data) {
        return <css.empty data-cy="transaction-empty">{t('noData')}</css.empty>;
    }

    return (
        <css.content data-cy="transaction-card">
            <TransactionDetails data={data} scrollRef={ref} />
            <TransactionActions hasCancelTicket={data?.cancelAllowed} links={data.links} transaction={data.transaction} collapsed={collapsed} onExpand={expand} />
        </css.content>
    );
}

export default TransactionCard;
